import { createTableColumn } from 'src/components/common/tableColumns/types';
import { commonFormatCurrencyWithType } from 'src/utils/currency';

type Options = {
  customStringPropValue?: string;
};

export const tableColumnAmount = createTableColumn<Options>((title, { customStringPropValue, ...other } = {}) => ({
  title,
  sortPropertyName: 'Amount',
  filter: {
    type: 'numeric',
    propertyName: 'Amount',
  },
  className: 'text-right amount',
  renderValue:
    customStringPropValue || (({ Amount, CurrencyType }) => commonFormatCurrencyWithType(Amount, CurrencyType)),
  ...other,
}));
